<template>
    <div class="main">
        <div>
            <el-button @click="sendMessage">发送消息</el-button>
        </div>
    </div>
</template>

<script>
import { sendAppChannel, appHandlerCode } from '@/utils/appChannelUtils.js';
export default {
    data() {
        return {

        }
    },
    mounted() {
    
    },
    methods: {

        sendMessage() {
            sendAppChannel({
                code: appHandlerCode.getToken,
                response: (res) => {
                    if(res.code == 200){
                        alert(res.data);
                    }else{
                        alert(res.message);
                    }
                }
            })
        }
    },
}
</script>

<style scoped>
.main {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
